import {
  resolvePlanAcres,
  stripPlanNameAcres,
} from '../toolkit/pages/plantingPlansLibraryUtils';
import { hydrateWizardAnswers } from '../toolkit/pages/plantingWizardUtils';
import { placeFromSavedGroup } from '../toolkit/pages/plantingMarkPlantedUtils';
import { planPreviewRequest, sanitizeBlendKey } from '../toolkit/pages/plantingPlanDisplay';

export const CLUB_SEED_READONLY = 'READ-ONLY';
export const CLUB_SEED_LOAD_ERROR = 'Unable to load shared plans.';
export const CLUB_SEED_DETAIL_ERROR = 'Could not load this plan.';
export const CLUB_SEED_EXPORT = 'EXPORT';
export const CLUB_SEED_EXPORT_ERROR = 'Could not export this plan.';
export const CLUB_SEED_EXPORTING = 'EXPORTING…';

export function clubSharedPlanTitle(group) {
  return stripPlanNameAcres(group?.name) || 'Untitled plan';
}

export function clubSharedPlanMeta(group) {
  const acres = resolvePlanAcres(group);
  const acresLabel = acres > 0 ? `${acres.toFixed(1)} AC` : '— AC';
  const season = group?.planting_season
    ? String(group.planting_season).toUpperCase()
    : '';
  const who = String(group?.owner_name || '').trim();
  const parts = [acresLabel];
  if (season) parts.push(season);
  if (who) parts.push(`Shared by ${who}`);
  return parts.join(' · ');
}

export function clubSharedPlanCountLabel(count) {
  const n = Number(count) || 0;
  return n === 1 ? '1 PLAN' : `${n} PLANS`;
}

/** plan-preview payload from the shared list row. Never GET /area-groups/:id/. */
export function sharedPlanPreviewRequest(group) {
  const answers = hydrateWizardAnswers(group?.wizard_answers, group?.planting_season);
  return planPreviewRequest({
    answers,
    place: placeFromSavedGroup(group),
    acres: resolvePlanAcres(group),
    blend: sanitizeBlendKey(group?.wizard_answers?.blend),
    draftSoilPh: group?.soil_ph,
  });
}
